var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13950_40031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22.7225C14.8415 22.7225 17.5668 21.5937 19.5761 19.5844C21.5854 17.5751 22.7142 14.8498 22.7142 12.0082C22.7142 9.16663 21.5854 6.44141 19.5761 4.43209C17.5668 2.42277 14.8415 1.29395 11.9999 1.29395C9.15833 1.29395 6.4331 2.42277 4.42379 4.43209C2.41447 6.44141 1.28564 9.16663 1.28564 12.0082C1.28564 14.8498 2.41447 17.5751 4.42379 19.5844C6.4331 21.5937 9.15833 22.7225 11.9999 22.7225Z",
    fill: "#F2F2F2",
    stroke: "#00B05C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71436 13.0798L10.8309 16.2941C12.2984 12.0804 13.5189 10.2324 16.2858 7.72266",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71436 13.0798L10.8309 16.2941C12.2984 12.0804 13.5189 10.2324 16.2858 7.72266",
    stroke: "#00B05C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13950_40031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.ec5c76c093f47a90f2dc5b7cefeba61d.svg";
export { ForwardRef as ReactComponent };